import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from "react";
import Image from "../../../base/multimedia/image/index.js";
import { CONSTANTS } from "./constants.js";
import * as S from "./styled.js";
import { DealsAlign, DealsPosition } from "./types.js";
export const Deals = ({ className , align =DealsAlign.none , position =DealsPosition.none , deals , resize =CONSTANTS.IMAGE  })=>/*#__PURE__*/ _jsx(S.Deals, {
        className: className,
        "data-testid": "Deals",
        $align: align,
        $position: position,
        children: Children.toArray(deals.map((deal)=>/*#__PURE__*/ _jsx(Image, {
                ...deal,
                ...resize,
                resize: resize
            })))
    });
export default Deals;

//# sourceMappingURL=index.js.map